module.exports = __webpack_public_path__ + "img/brain.dbfce53f.jpg";